import { AxiosInstance } from 'axios';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { CardType } from 'utils/customTypes';
import { JsonApiResponse } from '../types';
import {
  InsightCatalogue,
  InsightCategory,
  INSIGHT_TO_CATEGORY,
  INSIGHT_TO_CHART_TYPE,
} from 'types/store/normalized/insights/InsightCatalogue';
import { ChartType } from 'types/store/normalized/insights/chartTypes';
import intl from 'react-intl-universal';

export interface CardTypeApi {
  getChartData(dataUrl: string): Promise<JsonApiResponse>;
  getList(config?: unknown): Promise<CardType[]>;
}

interface CardTypeJsonApiResponse {
  jsonapi: {
    version: string;
  };
  links: {
    self: string;
  };
  data: Array<{
    type: string;
    id: string;
    attributes: {
      insightType: string;
      nameKey: string;
      descriptionKey: string;
      maxHeight: number;
      minHeight: number;
      maxWidth: number;
      minWidth: number;
      defaultHeight: number;
      defaultWidth: number;
      dataUrl: string;
    };
  }>;
}

export class AxiosCardTypeApi implements CardTypeApi {
  private axiosInstance: AxiosInstance = initAxios(
    config.get('dashboardBackendURL'),
    'dashboard'
  );
  private getListUrl: string = 'card-types/';

  async getList(): Promise<CardType[]> {
    const response = await this.axiosInstance.get<CardTypeJsonApiResponse>(
      this.getListUrl
    );

    const cardTypes: CardType[] = response.data.data.map((resource) => {
      const insightType = resource.attributes.insightType as InsightCatalogue;
      const category =
        INSIGHT_TO_CATEGORY[insightType] || InsightCategory.REQUESTS;

      const name = intl.get(`INSIGHT.NAME.${resource.attributes.nameKey}`);
      const description = intl.get(
        `INSIGHT.DESCRIPTION.${resource.attributes.descriptionKey}`
      );

      return {
        id: resource.id,
        insightId: insightType,
        name: name,
        description: description,
        defaultWidth: resource.attributes.defaultWidth,
        defaultHeight: resource.attributes.defaultHeight,
        minWidth: resource.attributes.minWidth,
        minHeight: resource.attributes.minHeight,
        maxWidth: resource.attributes.maxWidth,
        maxHeight: resource.attributes.maxHeight,
        dataUrl: resource.attributes.dataUrl,
        category: category,
        chartType: INSIGHT_TO_CHART_TYPE[insightType] || ChartType.KPI,
      };
    });

    return cardTypes;
  }

  getChartData(dataUrl: string): Promise<JsonApiResponse> {
    throw new Error('Method not implemented.');
  }

  getById(id: string): Promise<CardType> {
    throw new Error('Method not implemented.');
  }
}

export class NotImplementedCardTypeApi implements CardTypeApi {
  getChartData(dataUrl: string): Promise<JsonApiResponse> {
    throw new Error('Method not implemented.');
  }

  getList(config?: unknown): Promise<CardType[]> {
    throw new Error('Method not implemented.');
  }
}
